import { render, staticRenderFns } from "./VirtualAliases.vue?vue&type=template&id=d4ec26ea&"
import script from "./VirtualAliases.vue?vue&type=script&lang=js&"
export * from "./VirtualAliases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports